<template>
<div id="app">
  <mainCarousel></mainCarousel><br><br>
  <v-card
    class="mx-auto"
    max-width="1440"
  >
    <v-img
      class="white--text align-end"
      height="500px"
      src="https://www.songkhla.go.th/images/2016-12-25.gif"
    >
    </v-img>
    <img class="logo" src="../../assets/img/logo-new-transparent.png" width="200" height="200" alt="SMART CITY INFRALAB">
    <v-card-title>SMART CITY INFRALAB RUTS โครงการวิจัยและพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา</v-card-title>
    <br>
    
    <div id="head-thai"> <font color='red'>&lt;New&gt;</font> : <b>รับสมัครประกวดตราสัญลักษณ์ โครงการวิจัย Smart City Infralab</b> <a href="/news/logo-contest"> ดูรายละเอียด (คลิก)</a><!--<a href="https://bit.ly/2YqZxfy" target="_blank"> สมัครเข้าร่วมได้ที่ https://bit.ly/2YqZxfy (คลิก)</a>--></div>
    <div id="head-thai"> (โครงการการพัฒนาศักยภาพพื้นที่เมืองและโครงสร้างพื้นฐานรองรับยุทธศาสตร์เมืองอัจฉริยะของเทศบาลนครสงขลา)</div>
    <a href="./news/logo-contest"><img id="full-image" src="../../assets/news/logo_contest_brochure.jpg"></a>
    <v-btn x-large color="primary" to="/news/logo-contest">ดูรายละเอียด(คลิก)</v-btn> <br>
    
          

    <br><h4><div>ติดตามพวกเราได้ที่ Facebook Page : City infrastructure lab</div></h4>
    <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FCity-infrastructure-lab-104633281226873&tabs=timeline&width=500&height=1000&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="500" height="1000" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
    

    
  </v-card>
  
  
</div>

</template>


<script>
import mainCarousel from '../carousel/main.vue'
  export default {
    components: {
		mainCarousel
	},
    metaInfo: { title: 'กิจกรรม' },
  }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#full-image {
  display: block;
	object-fit: fill;
	width: 50%;
    margin-left: auto;
    margin-right: auto;

}
#head-thai {
  font-size:18pt;
  color: #043a20;
  text-align: left;
  padding-left: 50px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
.aaa {
  color: #42b983;
}
</style>
